export default "__VITE_ASSET__CWAPdBBX__"